<template>
    <v-toolbar fixed color="white">
      <img id="copq-logo" src="../../public/images/COPQ-logo.png" alt="" @click="refresh">
      <img id="sstv-logo" src="../../public/images/sixsigmatv-logo_1.png" alt="">
    </v-toolbar>
</template>

<script>
export default {
  name: 'navbar',
  props: {},
  methods: {
    refresh() {
      location.reload();
    }
  }
}
</script>

<style scoped>
.v-toolbar {
  display: flex;
  justify-content: center;
  padding-top: 1%;
  padding-bottom: 1%;
}
#copq-logo {
  height: 4rem;
  cursor: pointer;
  padding-right: 1rem;
  border-right: 1px solid black;
}

#sstv-logo {
  height: 3rem;
  padding-left: 1rem;
}

@media screen and (min-width: 320px) and (max-width: 1020px){
  .v-toolbar {
    padding-top: 2%;
    padding-bottom: 2%;
  }
}

@media screen and (min-width: 320px) and (max-width: 800px){
  #copq-logo {
      height: 3rem;
  }
  #sstv-logo {
    height: 2rem;
  }
}
</style>
